const REJECTED_KEYS = new Set([',', '.', '-', '+', 'e', 'E']);

export function rejectNonIntegerKeys(event: KeyboardEvent): void {
  if (REJECTED_KEYS.has(event.key)) event.preventDefault();
}

export function toWholeNumber(value: number | null, min: number): number | null {
  return value !== null && Number.isInteger(value) && value >= min ? value : null;
}
